"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_QUERIES = exports.SCREEN_SIZES_IN_PX = void 0;
var EDeviceSizeString;
(function (EDeviceSizeString) {
    EDeviceSizeString["MobileS"] = "320px";
    EDeviceSizeString["MobileM"] = "375px";
    EDeviceSizeString["MobileL"] = "425px";
    EDeviceSizeString["TabletS"] = "700px";
    EDeviceSizeString["Tablet"] = "768px";
    EDeviceSizeString["Laptop"] = "1024px";
    EDeviceSizeString["LaptopL"] = "1440px";
    EDeviceSizeString["Desktop"] = "2560px";
})(EDeviceSizeString || (EDeviceSizeString = {}));
exports.SCREEN_SIZES_IN_PX = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tabletS: 700,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop: 2560
};
exports.MEDIA_QUERIES = {
    mobileS: `(min-width: ${EDeviceSizeString.MobileS})`,
    mobileM: `(min-width: ${EDeviceSizeString.MobileM})`,
    mobileL: `(min-width: ${EDeviceSizeString.MobileL})`,
    tabletS: `(min-width: ${EDeviceSizeString.TabletS})`,
    tablet: `(min-width: ${EDeviceSizeString.Tablet})`,
    laptop: `(min-width: ${EDeviceSizeString.Laptop})`,
    laptopL: `(min-width: ${EDeviceSizeString.LaptopL})`,
    desktop: `(min-width: ${EDeviceSizeString.Desktop})`,
    desktopL: `(min-width: ${EDeviceSizeString.Desktop})`
};
//# sourceMappingURL=style.js.map